import React from 'react';

import Loader from '../Loader/Loader';
import Text from '../Text/Text';
import Locale from '../../Translate/Locale';

import styles from './ProgressIndicator.scss';

type Props = {
  children: string;
};

function ProgressIndicator(props: Props) {
  return (
    <div className={styles.container}>
      <Loader />
      <Text className={styles.text}>
        <Locale>{props.children}</Locale>
      </Text>
    </div>
  );
}

export default React.memo(ProgressIndicator);
